import React, { useEffect, useState } from "react";
import Chatheader from "../chatheader/chatheader";
import { useStateValue } from '../../../../stateprovider';
import "./chat.css";


const ChatComp = () => {
    const chat = [
        { text: "Hello, thanks for your response..." },
        { text: "It’s been occuring for like 2 days now and I used drug hoping it would stop but then it stopped for a while and came back with full force..." },
    ]
    const [{ }, dispatch] = useStateValue();
    const [chatText, setChatText] = useState("");

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: true
        });
        dispatch({
            type: "APP_ICON_STATE",
            appIconState: 0
        })
    }, []);

    return <div className="app_complaint">
        <Chatheader />
        <div className="app_chat_time">
            <div className="app_chat_time_conatiner">
                <div className="app_chat_time_progress">
                    <div className="app_chat_timep_col"></div>
                </div>
            </div>
            <div className="app_chat_time_text">
                <span>11 mins</span>
            </div>
        </div>
        <div className="app_chat_container">
            <div className="app_chat_box">
                <div className="app_chat_box_sender">
                    {chat.map((c, index) => {
                        return <div className="app_chat_box_sender_box" key={index}>
                            <p>{c.text}</p>
                        </div>
                    })}
                </div>
            </div>
            <div className="app_chat_input_container">
                <div className="app_chat_input_row">
                    <input type="text" placeholder="your message here..." onChange={(e) => {
                        setChatText(e.target.value);
                    }} />
                    {
                        chatText?.length >= 1 ?
                            <></>
                            : <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
                                    <path d="M23.3562 20.1189C23.3562 20.482 23.2122 20.8303 22.9559 21.087C22.6996 21.3438 22.352 21.488 21.9896 21.488H5.59017C5.22772 21.488 4.88012 21.3438 4.62382 21.087C4.36753 20.8303 4.22355 20.482 4.22355 20.1189V11.9047C4.22355 11.5416 4.36753 11.1933 4.62382 10.9366C4.88012 10.6798 5.22772 10.5356 5.59017 10.5356H7.19185C8.27863 10.535 9.32072 10.1022 10.0891 9.33222L11.2234 8.19865C11.4789 7.94255 11.8254 7.79832 12.1868 7.79751H15.3902C15.7526 7.79759 16.1002 7.94188 16.3564 8.19865L17.4879 9.33222C17.8687 9.71379 18.3208 10.0165 18.8184 10.2229C19.316 10.4294 19.8493 10.5357 20.3879 10.5356H21.9896C22.352 10.5356 22.6996 10.6798 22.9559 10.9366C23.2122 11.1933 23.3562 11.5416 23.3562 11.9047V20.1189ZM5.59017 9.16656C4.86527 9.16656 4.17006 9.45504 3.65748 9.96853C3.1449 10.482 2.85693 11.1785 2.85693 11.9047L2.85693 20.1189C2.85693 20.8451 3.1449 21.5416 3.65748 22.0551C4.17006 22.5686 4.86527 22.857 5.59017 22.857H21.9896C22.7145 22.857 23.4097 22.5686 23.9223 22.0551C24.4349 21.5416 24.7228 20.8451 24.7228 20.1189V11.9047C24.7228 11.1785 24.4349 10.482 23.9223 9.96853C23.4097 9.45504 22.7145 9.16656 21.9896 9.16656H20.3879C19.6631 9.16641 18.968 8.87783 18.4555 8.3643L17.324 7.23073C16.8115 6.7172 16.1164 6.42862 15.3916 6.42847H12.1882C11.4634 6.42862 10.7683 6.7172 10.2558 7.23073L9.12424 8.3643C8.61178 8.87783 7.91669 9.16641 7.19185 9.16656H5.59017Z" fill="#5AC7E2" />
                                    <path d="M13.79 18.749C12.8839 18.749 12.0149 18.3884 11.3742 17.7465C10.7335 17.1046 10.3735 16.2341 10.3735 15.3263C10.3735 14.4186 10.7335 13.548 11.3742 12.9062C12.0149 12.2643 12.8839 11.9037 13.79 11.9037C14.6962 11.9037 15.5652 12.2643 16.2059 12.9062C16.8466 13.548 17.2066 14.4186 17.2066 15.3263C17.2066 16.2341 16.8466 17.1046 16.2059 17.7465C15.5652 18.3884 14.6962 18.749 13.79 18.749ZM13.79 20.118C15.0586 20.118 16.2752 19.6132 17.1722 18.7146C18.0693 17.8159 18.5732 16.5972 18.5732 15.3263C18.5732 14.0555 18.0693 12.8367 17.1722 11.9381C16.2752 11.0395 15.0586 10.5347 13.79 10.5347C12.5215 10.5347 11.3049 11.0395 10.4078 11.9381C9.51082 12.8367 9.00688 14.0555 9.00688 15.3263C9.00688 16.5972 9.51082 17.8159 10.4078 18.7146C11.3049 19.6132 12.5215 20.118 13.79 20.118ZM6.95695 12.5882C6.95695 12.7698 6.88496 12.9439 6.75681 13.0723C6.62867 13.2006 6.45487 13.2728 6.27364 13.2728C6.09242 13.2728 5.91861 13.2006 5.79047 13.0723C5.66232 12.9439 5.59033 12.7698 5.59033 12.5882C5.59033 12.4067 5.66232 12.2326 5.79047 12.1042C5.91861 11.9758 6.09242 11.9037 6.27364 11.9037C6.45487 11.9037 6.62867 11.9758 6.75681 12.1042C6.88496 12.2326 6.95695 12.4067 6.95695 12.5882Z" fill="#5AC7E2" />
                                </svg>
                                <input type="file" className="app_chat_file" />
                            </>
                    }

                </div>
                <div className="app_chat_input_button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                        <path d="M18.8595 9.27463C18.8599 9.12596 18.8179 8.98022 18.7385 8.85455C18.659 8.72887 18.5455 8.62848 18.4111 8.56518L1.91668 0.733783C1.77278 0.667874 1.61233 0.647357 1.45663 0.674956C1.30093 0.702554 1.15735 0.776963 1.04497 0.888298C0.932585 0.999634 0.856713 1.14263 0.82743 1.29829C0.798146 1.45395 0.816837 1.61491 0.881021 1.75978L3.69175 8.41333L10.6907 8.44561L10.6829 10.0025L3.66204 9.959L0.790991 16.5829C0.728576 16.7261 0.710562 16.8849 0.739278 17.0387C0.767994 17.1924 0.842118 17.334 0.952049 17.4452C1.06516 17.5551 1.20884 17.6282 1.36415 17.6548C1.51946 17.6814 1.67912 17.6602 1.82206 17.5941L18.3931 9.96738C18.5285 9.90816 18.6442 9.81159 18.7268 9.68893C18.8093 9.56628 18.8554 9.42259 18.8595 9.27463Z" fill="white" />
                    </svg>
                </div>
            </div>
        </div>

    </div>
}
export default ChatComp;